import uiRouter from 'angular-ui-router';
import { areasydneyDirective } from './areasydney.directive';
import { areasydneyStore } from './areasydney.store';

export const areasydney = angular
  .module('areasydney', [uiRouter])
  .config($stateProvider => {
    $stateProvider.state('app.areasydney', {
      url: '/sydney-skip-hire.aspx',
      template: '<areasydney></areasydney>',
      data: {
        metaTitle: 'Skip hire and skip bins in Sydney - Rentaskip Australia',
        metaDescription:
          'Skip hire and skip bins in Sydney. Reliable service for residential, trade and business customers. Book online or call our offices to speak with a consultant.',
        metaKeywords: 'Skip bin hire, FAQ'
      }
    });
  })
  .directive('areasydney', areasydneyDirective)
  .factory('areasydneyStore', areasydneyStore);



/** WEBPACK FOOTER **
 ** ./src/app/components/areasydney/areasydney.js
 **/